import { createLogisticsApi, createSuppliersApi } from '@d-orca/shared/client/apis';
import { authedFetch } from '@apis/auth';

// The factory and its errors live in shared so an `instanceof` here matches
// what the factory throws; re-exported to keep this module's import sites.
export {
  LogisticsNotFoundError,
  LogisticsSiteNotLinkedError,
  logisticsQueryRetry,
  DeliveryOrderConflictError,
  StatusInUseError,
  SupplierNameTakenError,
  SupplierPhoneInvalidError,
  type ISnapshotBody,
  type DeliveryOrderBody,
  type DeliveryOrderPatch,
  type DeliveryOrderSubmit,
  type DeliveryOrderCreateBody,
  type DeliveryOrderLineBody,
  type DeliveryLineBody,
  type DeliverySourceConflictReason,
  type DeliveryOrderConflictReason,
} from '@d-orca/shared/client/apis';
export const {
  fetchSiteLogistics,
  fetchDeliveryStatuses,
  postInventorySnapshot,
  postDeliveryOrder,
  patchDeliveryOrder,
  deleteDeliveryOrder,
  addDeliveryLine,
  deleteInventoryMaterial,
  postDeliveryStatus,
  renameDeliveryStatus,
  reorderDeliveryStatuses,
  deleteDeliveryStatus,
} = createLogisticsApi(authedFetch);
export const { fetchSuppliers } = createSuppliersApi(authedFetch);
